import { ErrorFallBack } from '@drisk-ai/ui';
import { useNavigate } from '@tanstack/react-router';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <ErrorFallBack
      title="Not Found"
      description="The page you are looking for does not exist"
      buttonLabel="Go Home"
      onClick={() => navigate({ to: '/', replace: true })}
    />
  );
};
